import { Component } from "react";
import * as TagPrisonUtil from "../uidispatcherapi/TagPrisonUtil";
import GtmEventsConsumer from "../uidispatcherapi/GtmEventsConsumer";
export class TagPrison extends Component<Record<PropertyKey, never>> {
	render() {
		const iframe = (
			// eslint-disable-next-line jsx-a11y/iframe-has-title
			<iframe
				sandbox="allow-scripts allow-same-origin"
				id="tagprison-iframe-id"
				src={TagPrisonUtil.getIFrameDomain(window)}
				style={{
					display: "none",
				}}
				ref={e => GtmEventsConsumer.setIframeRef(e)}
				aria-hidden
			/>
		);
		return TagPrisonUtil.showIFrame(window) ? iframe : null;
	}
}
